import { PosthogEventTypes } from "@rachelallyson/stratum-posthog-js";

export enum EventType {
  BASE = PosthogEventTypes.CAPTURE,
  INTERACTION = PosthogEventTypes.CAPTURE,
  FORM_SUBMISSION = PosthogEventTypes.CAPTURE,
  PAGE_VIEW = PosthogEventTypes.CAPTURE,
  FILTER = PosthogEventTypes.CAPTURE,
  BUTTON_CLICK = PosthogEventTypes.CAPTURE,
  TABLE_FILTER = PosthogEventTypes.CAPTURE,
  ERROR = PosthogEventTypes.ERROR,
  IDENTIFY = PosthogEventTypes.IDENTIFY,
  RESET = PosthogEventTypes.RESET,
}

/**
 * Ensures that every value in the keys object is a key in the catalog.
 * @template Keys - The object containing event key constants (as const).
 */
export type EventCatalogFromKeys<Keys extends Record<string, string>> = Record<
  Keys[keyof Keys],
  {
    description: string;
    eventType: EventType;
    id: string | number;
  }
>;
